module.exports = __webpack_public_path__ + "static/img/pc-09.bb4466f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/pc-09.jpg
// module id = qhDa
// module chunks = 1